import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum OrganizationKind {
  Company = 'company',
  Personal = 'personal',
  NGO = 'ngo',
  Government = 'government',
  Owner = 'owner',
  Self = 'self',
}

export const organizationCreateSchema = z.object({
  name: z.string().min(2, 'ORG_INVALID_NAME'),
  kind: z.nativeEnum(OrganizationKind),
  contactPhone: z
    .string()
    .regex(/^\+?[1-9]\d{1,14}$/, 'ORG_INVALID_PHONE')
    .or(z.literal('')),
  contactEmail: z.string().email('ORG_INVALID_EMAIL').or(z.literal('')),
  addressStreet: z.string(),
  addressCity: z.string(),
  addressState: z.string(),
  addressZipCode: z.string(),
  website: z.string({
    // eslint-disable-next-line camelcase
    required_error: 'ORG_INVALID_WEBSITE',
    // eslint-disable-next-line camelcase
    invalid_type_error: 'ORG_INVALID_WEBSITE',
  }),
  addressCountry: z
    .string()
    .regex(/^[A-Za-z]{2}$/, 'ORG_INVALID_COUNTRY')
    .or(z.literal('')),
  companyTeamSize: z.object({
    from: z.number().min(1),
    to: z.number().nullable(),
  }),
  hasCompletedOnboarding: z.boolean().default(false),
});
export type OrganizationCreate = z.infer<typeof organizationCreateSchema>;

export const organizationSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(organizationCreateSchema)
  // used to remove extras that we might need internally but not externally
  // for example: isArchived
  .strip();

export type Organization = z.infer<typeof organizationSchema>;
